<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-form-item :label="labelText(zdItem.label)">
          <el-input
            :placeholder="$t('view.placeholder')"
            :disabled="setupDisable() || getAuthShow()"
            v-model="zdFormattedValueSpecification"
            :class="{ 'question-mark-highlight': hasQuestionMarkSpecification }"
          >
            <!-- 如果有提示信息，则显示默认值按钮 -->
            <template v-if="zdItem.tips_value?.specification" #suffix>
              <el-popover
                placement="top-start"
                :content="zdItem.tips_value.specification"
                trigger="hover"
                class="text-center"
              >
                <el-button
                  slot="reference"
                  icon="el-icon-edit"
                  size="small"
                  type="primary"
                  :disabled="setupDisable() || getAuthShow()"
                  @click="defaultValueHandle(zdItem.tips_value.specification, 'specification')"
                >
                  {{ $t("action.default") }}
                </el-button>
              </el-popover>
            </template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="labelText(zdItem.label)">
          <el-input
            :placeholder="$t('view.placeholder')"
            :disabled="setupDisable() || getAuthShow()"
            v-model="zdFormattedValueTestMethod"
            :class="{ 'question-mark-highlight': hasQuestionMarkTestMethod }"
          >
            <!-- 如果有提示信息，则显示默认值按钮 -->
            <template v-if="zdItem.tips_value?.test_method" #suffix>
              <el-popover
                placement="top-start"
                :content="zdItem.tips_value.test_method"
                trigger="hover"
                class="text-center"
              >
                <el-button
                  slot="reference"
                  icon="el-icon-edit"
                  size="small"
                  type="primary"
                  :disabled="setupDisable() || getAuthShow()"
                  @click="defaultValueHandle(zdItem.tips_value.test_method, 'test_method')"
                >
                  {{ $t("action.default") }}
                </el-button>
              </el-popover>
            </template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import base from "@/common/base.js";
export default {
  name: "ZDTwoColumnInput", // 设置组件名称为 ZDInput
  props: {
    // 组件的唯一 ID，用于在 Vuex 中标识和管理其状态
    zdId: {
      type: String,
      required: true,
    },
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  computed: {
    // 从 Vuex 获取当前组件的整个状态
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    // 获取当前组件的状态对象
    zdComponentState() {
      return this.zdGetComponentState(this.zdId);
    },
    // 从状态对象中获取各个字段
    zdItem() {
      return this.zdComponentState;
    },
    labelText() {
      return (label) => {
        let key = "content." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
    // 分别处理 specification 和 test_method
    zdFormattedValueSpecification: {
      get() {
        return this.zdItem.value?.specification || ""; // 获取 specification 的值
      },
      set(value) {
        this.updateNestedField("specification", value); // 更新 specification 的值
      },
    },
    zdFormattedValueTestMethod: {
      get() {
        return this.zdItem.value?.test_method || ""; // 获取 test_method 的值
      },
      set(value) {
        this.updateNestedField("test_method", value); // 更新 test_method 的值
      },
    },
    hasQuestionMarkSpecification() {
      const spec = this.zdFormattedValueSpecification || "";
      return spec.includes('?') || spec.includes('？');
    },
    hasQuestionMarkTestMethod() {
      const method = this.zdFormattedValueTestMethod || "";
      return method.includes('?') || method.includes('？');
    },
  },
  created() {
    // 监听页面状态变化
    this.$EventBus.$on("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$on("tabChanged", this.handleTabChanged);
  },
  
  beforeDestroy() {
    // 清理事件监听器
    this.$EventBus.$off("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$off("tabChanged", this.handleTabChanged);
  },
  
  methods: {
    // 映射 Vuex 的动作
    ...mapActions("zdInput", ["updateComponent"]),
    
    /**
     * 设置组件是否禁用
     */
    setupDisable() {
      const pageStatus = this.pageStatus;
      
      // 如果页面状态是Detail，所有字段都不可编辑
      if (pageStatus === "Detail") {
        return true;
      }
      
      // 返回字段本身的disabled配置
      return this.zdItem.disabled || false;
    },
    
    /**
     * 处理页面状态变化
     */
    handlePageStatusChange() {
      // console.info("ZDTwoColumnInput: Page status changed to", pageStatus, "for component", this.zdId);
      
      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    },
    
    /**
     * 处理标签页变化
     */
    handleTabChanged() {
      // console.info("ZDTwoColumnInput: Tab changed to", data.tabName, "with status", data.pageStatus, "for component", this.zdId);
      
      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    },
    
    // 更新嵌套字段的方法
    updateNestedField(field, value) {
      const updatedValue = {
        ...this.zdItem.value, // 保留其他字段的值
        [field]: value, // 更新目标字段
      };
      this.zdUpdateComponent({
        id: this.zdId,
        field: "value",
        value: updatedValue,
      });
    },
    getAuthShow(){
      return base.getAuthShow();
    },
    zdUpdateComponent(payload) {
      this.updateComponent(payload); // 更新组件状态
    },
    defaultValueHandle(value, field) {
      this.updateNestedField(field, value); // 更新指定字段的值
    },
  },
};
</script>
<style src="./input-highlight.css" scoped>

</style>